var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 12.5C2.2974 12.5 1.98351 12.3694 1.7224 12.1083C1.46128 11.8472 1.33073 11.5333 1.33073 11.1667V2.5H0.664062V1.16667H3.9974V0.5H7.9974V1.16667H11.3307V2.5H10.6641V11.1667C10.6641 11.5333 10.5335 11.8472 10.2724 12.1083C10.0113 12.3694 9.6974 12.5 9.33073 12.5H2.66406ZM9.33073 2.5H2.66406V11.1667H9.33073V2.5ZM3.9974 9.83333H5.33073V3.83333H3.9974V9.83333ZM6.66406 9.83333H7.9974V3.83333H6.66406V9.83333Z",
    fill: "#FF7F2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.caec8ca39f7be9abd5ee3e41e08ecb51.svg";
export { ForwardRef as ReactComponent };